<template>
    <div class="m-ad">
        <div class="full-ad">
            <a href="javascript:;"
               class="close"
               @click="adFallUp"></a>
            <img :src="full"
                 alt="">
        </div>
        <div class="top-ad">
            <img :src="top"
                 alt="">
        </div>
    </div>
</template>

<script>
import $ from "jquery"
import top from "../../assets/images/zg_px_ad.jpg"
import full from "../../assets/images/zg_px.jpg"

export default {
    data () {
        return {
            $,
            top,
            full
        }
    },
    methods: {
        adFallUp () {
            let img = $('.top-ad').find('img');
            $('.full-ad').css('position', 'absolute').stop().animate({ height: 0 }, 1000);
            setTimeout(function () {
                $(".top-ad").stop().animate({ height: img.height() }, 600);
            }, 1000);
        }
    },
    mounted () {
        let that = this;
        setTimeout(function () {
            that.adFallUp();
        }, 3000)
    }
}
</script>

<style scoped>
.m-ad {
    background: #fff;
    padding-top: 0.3rem;
}
.top-ad {
    height: 0;
    transition: all 0.5s ease;
    overflow: hidden;
}
.top-ad img {
    width: 100%;
}
.full-ad {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 200;
    overflow: hidden;
    background: #bababa;
}
.full-ad img {
    width: 100%;
}
.full-ad .close {
    display: block;
    width: 1rem;
    height: 1rem;
    right: 0.5rem;
    top: 0.4rem;
    position: absolute;
    border-radius: 50%;
    background: url("../../assets/images/btn.png") no-repeat;
    background-size: 100%;
}
</style>